import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface ConfirmClaimGroupCommandArgs {
  claimGroupId: string;
  phoneNumber?: string;
  mail?: string;
  swornStatement?: boolean;
  generalSalesCondition?: string;
  iMEI?: string;
  devicePassword?: string;
  serialNumber?: string;
  invoiceId?: string;
  sourceTokenId?: string;
  issueDate?: string;
  origin?: string;
  ticketId?: string;
}

export const confirmClaimGroupRequest = ({
  claimGroupId,
  phoneNumber,
  mail,
  swornStatement,
  generalSalesCondition,
  iMEI,
  devicePassword,
  serialNumber,
  invoiceId,
  sourceTokenId,
  issueDate,
  origin,
  ticketId,
}: ConfirmClaimGroupCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/confirmation`,
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: {
      phoneNumber,
      mail,
      swornStatement,
      generalSalesCondition,
      iMEI,
      devicePassword,
      serialNumber,
      invoiceId,
      sourceTokenId,
      issueDate,
      origin,
      ticketId,
    },
  },
});

export const confirmClaimGroupCommand = async (
  args: ConfirmClaimGroupCommandArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      confirmClaimGroupRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
